import React, { useState, useEffect } from 'react';
import './App.css';
import Login from './Login';
import Dashboard from './Dashboard';

function App() {
  // Başlangıçta localStorage'ı kontrol ederek kullanıcının giriş durumunu alıyoruz.
  const [isLoggedIn, setLoggedIn] = useState(() => {
    return localStorage.getItem('isLoggedIn') === 'true';
  });

  const [currentUser, setCurrentUser] = useState(() => {
    const savedUser = localStorage.getItem('user');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  // isLoggedIn durumu değiştiğinde localStorage'ı güncelle
  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  const handleLoginSuccess = (user) => {
    // Giriş başarılı olduğunda state'i güncelliyoruz.
    setCurrentUser(user);
    localStorage.setItem('user', JSON.stringify(user));
    setLoggedIn(true);
  };

  const handleLogout = () => {
    // Çıkış yapıldığında state'i ve localStorage'ı temizliyoruz.
    setCurrentUser(null);
    localStorage.removeItem('user');
    setLoggedIn(false);
  };

  return (
    isLoggedIn
      ? <Dashboard onLogout={handleLogout} currentUser={currentUser} onUserUpdate={handleLoginSuccess} />
      : <Login onLoginSuccess={handleLoginSuccess} />
  );
}

export default App;